<template>
  <div class="mx-3">
    <v-row>
      <v-col
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <setup-claims-claim-transaction-date-validity-rule-dialog-create
          v-if="$hasPermissionTo(['create claim transaction date validity rules'])"
          @created="loadData"
        />
      </v-col>
      <v-spacer />

      <v-col
        class="py-0"
        cols="12"
        lg="3"          
        md="12"
        sm="12"
        xl="2"
      >
        <v-select
          v-model="statusFilter"
          :items="items"
          item-text="state"
          item-value="value"
          label="Rule's Status"
          placeholder="Active / Deleted"
        />
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="filteredClaimTransactionDateValidityRules"
      :loading="tableLoading"
    >
      <template v-slot:item.requires_remark="{ item }">
        <div>
          <span>
            <v-icon
              v-if="item.requires_remark"
              color="hrissecondary"
            >
              mdi-check-outline
            </v-icon>
            <v-icon
              v-else
              color="error"
            >
              mdi-close-outline
            </v-icon>   
          </span>
        </div>
      </template>

      <template v-slot:item.requires_additional_approver="{ item }">
        <div>
          <span>
            <v-icon
              v-if="item.requires_additional_approver"
              color="hrissecondary"
            >
              mdi-check-outline
            </v-icon>
            <v-icon
              v-else
              color="error"
            >
              mdi-close-outline
            </v-icon>   
          </span>
        </div>
      </template>

      <template v-slot:item.action="{ item }">
        <span
          v-if="statusFilter"
          style="display:inline-block;width:80px"
        >
          <setup-claims-claim-transaction-date-validity-rule-dialog-edit
            v-if="$hasPermissionTo(['update claim transaction date validity rules'])"
            :claim-transaction-date-validity-rule="item"
            @updated="loadData"
          />
          <setup-claims-claim-transaction-date-validity-rule-dialog-delete
            v-if="$hasPermissionTo(['delete claim transaction date validity rules'])"
            :claim-transaction-date-validity-rule="item"
            @deleted="loadData"
          />
        </span>
        <span v-else>
          <setup-claims-claim-transaction-date-validity-rule-dialog-restore
            v-if="$hasPermissionTo(['restore claim transaction date validity rules'])"
            :claim-transaction-date-validity-rule="item"
            @restored="loadData"
          />
        </span>
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    components: {
      SetupClaimsClaimTransactionDateValidityRuleDialogCreate: () => import('@/components/hris/setup/claims/claim-transaction-date-validity-rule/DialogCreate'),
      SetupClaimsClaimTransactionDateValidityRuleDialogEdit: () => import('@/components/hris/setup/claims/claim-transaction-date-validity-rule/DialogEdit'),
      SetupClaimsClaimTransactionDateValidityRuleDialogDelete: () => import('@/components/hris/setup/claims/claim-transaction-date-validity-rule/DialogDelete'),
      SetupClaimsClaimTransactionDateValidityRuleDialogRestore: () => import('@/components/hris/setup/claims/claim-transaction-date-validity-rule/DialogRestore'),
    },
    data () {
      return {
        claimTransactionDateValidityRules: [],
        trashedClaimTransactionDateValidityRules: [],
        headers: [
          {
            text: 'Start Day',
            align: 'center',
            value: 'start_day',
            sortable: false,
          },
          {
            text: 'End Day',
            align: 'center',
            value: 'end_day',
            sortable: false,
          },
          {
            text: 'Requires Remark',
            align: 'center',
            value: 'requires_remark',
            sortable: false,
          },
          {
            text: 'Requires Additional Approver',
            align: 'center',
            value: 'requires_additional_approver',
            sortable: false,
          },
          {
            text: '',
            sortable: false,
            value: 'action',
          },
        ],
        statusFilter: { state: 'Active', value: true },
        items: [
          { state: 'Active', value: true },
          { state: 'Deleted', value: false },
        ],
        tableLoading: true,
        combinedClaimTransactionDateValidityRules: [],
      }
    },
    computed: {
      filteredClaimTransactionDateValidityRules () {
        return this.statusFilter ? this.claimTransactionDateValidityRules : this.trashedClaimTransactionDateValidityRules
      },
    },
    created () {
      this.loadData()
    },
    methods: {
      loadData () {
        Promise.all([
          this.$api.claimTransactionDateValidityRules().list(),
          this.$api.claimTransactionDateValidityRules().listTrashed(),
        ]).then(([claimTransactionDateValidityRules, trashedClaimTransactionDateValidityRules]) => {
          this.claimTransactionDateValidityRules = claimTransactionDateValidityRules.data
          this.trashedClaimTransactionDateValidityRules = trashedClaimTransactionDateValidityRules.data

          this.combinedClaimTransactionDateValidityRules = claimTransactionDateValidityRules.data.concat(trashedClaimTransactionDateValidityRules.data)

          this.tableLoading = false
        })
      },
    },
  }
</script>
